import React from "react";
import { useTranslation } from "react-i18next";

import DarkDefaultProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png"; // 다크모드이미지
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png"; // 라이트모드이미지
import i18n from "~/i18n";
import { useGlobalStore } from "~/store";

const CardFront = ({ userInfo, userProfile }) => {
	const { t } = useTranslation();

	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();

	return (
		<section className="c__card front">
			<div className="content-wrap">
				<div className="content">
					<div className="profile-img">
						<img
							src={
								userInfo.img ||
								(theme === "dark" ? DarkDefaultProfileImg : LightDefaultProfileImg)
							}
							alt={i18n.language === "ko" ? "기본이미지" : "default image"}
						/>
						<div className="profile-authority">
							{userInfo.role === "admin"
								? t("pages.myPage.userType.admin")
								: userInfo.role === "user"
								? t("pages.myPage.userType.member")
								: t("pages.myPage.userType.member")}
						</div>
					</div>
					<div className="profile-position">
						{userInfo.role === "admin"
							? t("pages.myPage.userType.admin")
							: userInfo.role === "user" && t("pages.myPage.userType.member")}
					</div>
					{/* <h3 className="profile-name">{responseData.Company.name ? responseData.Company.name : '-'}</h3> */}
					<h3 className="profile-name">{userProfile.name}</h3>
					<p className="intro-myself">
						{userProfile.introduction &&
							userProfile.introduction.split("\n").map((text) => {
								return (
									<span>
										{text}
										<br />
									</span>
								);
							})}
					</p>
				</div>
			</div>
		</section>
	);
};

export default CardFront;
